import { put, call, takeLatest, fork, all } from "redux-saga/effects";
import { callApi, createReducer, createAction } from "dorothy/utils";

export const GET_TAGS_REQUEST = "GET_TAGS_REQUEST";
export const GET_TAGS_RESPONSE = "GET_TAGS_RESPONSE";
export const GET_TAGS_ERROR = "GET_TAGS_ERROR";

function* getTags(action) {
  try {
    let endpoint = "/api/tags";
    if (action.payload && action.payload.search) {
      endpoint += `?search=${encodeURIComponent(action.payload.search)}`;
    }
    const response = yield call(callApi, "GET", endpoint);
    if (response) {
      yield put(createAction(GET_TAGS_RESPONSE, response));
    }
  } catch (error) {
    console.log(error);
    yield put(createAction(GET_TAGS_ERROR));
  }
}

function* watchGetTags() {
  yield takeLatest(GET_TAGS_REQUEST, getTags);
}

export const tagSagas = function* () {
  yield all([fork(watchGetTags)]);
};

const initTags = {
  data: [],
  loading: false,
};

const tagActionHandlers = {
  [GET_TAGS_REQUEST]: (state) => ({ ...state, loading: true }),
  [GET_TAGS_RESPONSE]: (state, action) => ({
    ...state,
    loading: false,
    data: action.payload,
  }),
  [GET_TAGS_ERROR]: (state) => ({ ...state, loading: false }),
};

export const tagReducer = createReducer(initTags, tagActionHandlers);
